'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@/src/styles/stylebook';
import { useAnchorSpy } from '@/src/hooks/useAnchorSpy';
export default function AnchorMenu(t0) {
  const $ = _c(13);
  const {
    items,
    className: t1,
    offset: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const offset = t2 === undefined ? 96 : t2;
  let t3;
  if ($[0] !== items || $[1] !== offset) {
    t3 = {
      items,
      offset
    };
    $[0] = items;
    $[1] = offset;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    activeId
  } = useAnchorSpy(t3);
  let t4;
  if ($[3] !== className) {
    t4 = cx("px-marg py-gutter scroll-hide sticky top-[calc(3.6125rem-var(--spacing-gutter))] z-50 flex gap-4 overflow-x-auto select-none", "max-md:bg-system-gnbbg max-md:top-[var(--headerh)] max-md:pt-0", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== activeId || $[6] !== items) {
    let t6;
    if ($[8] !== activeId) {
      t6 = t7 => {
        const {
          id,
          label
        } = t7;
        return <a key={`anchor-${id}`} href={`#${id}`} className={cx("h5 whitespace-pre transition-opacity", activeId === id ? "opacity-100" : "opacity-30")}>{label}</a>;
      };
      $[8] = activeId;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = items.map(t6);
    $[5] = activeId;
    $[6] = items;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}